/**
 * Product-category content — one entry per dropdown item.
 * Each becomes the /products/:slug page.
 */
export const CATEGORIES = {
  "steel-doors": {
    slug: "steel-doors",
    title: "Steel Doors.",
    eyebrow: "Category",
    tagline: "French, Pivot, Bifold, Sliding, Custom",
    description:
      "Slim FerroFinestra sight-lines with the strength and durability of steel. Every door engineered around your drawings, from single-leaf entries to oversized pivots.",
    seo: {
      title: "Steel Doors NZ — Architectural & Custom Steel Doors | EUROSTEEL",
      description:
        "Slim-profile architectural steel doors for New Zealand: French, pivot, bifold and sliding — engineered around your drawings and finished in Auckland.",
      keywords: [
        "steel doors NZ",
        "architectural steel doors NZ",
        "custom steel doors NZ",
        "luxury steel doors NZ",
      ],
    },
    intro:
      "Steel is where architecture and craft meet without compromise. Each EUROSTEEL door is drawn, cut and welded around a specific building — French pairs onto a garden loggia, oversized pivots into a stone portico, arched entrances back into heritage joinery. The FerroFinestra profile lets us hold sight-lines that would collapse in almost any other material, then finish them in matte black, warm bronze or a colour-matched powdercoat.",
    relatedSlugs: ["luxury-entrances", "steel-windows"],
    heroImage:
      "https://customer-assets-v7afamib.emergentagent.net/job_fe0c775c-382e-4bf1-ab8e-bb795dea130b/artifacts/77v6vg5z_DSCF1756.webp",
    items: [
      { name: "French Doors", desc: "Classic double-leaf steel doors — brass or matte-black hardware." },
      { name: "Pivot Doors", desc: "Oversized single-panel doors on floor-mounted hinges." },
      { name: "Bifold", desc: "Multi-leaf folding systems that open whole rooms outward." },
      { name: "Sliding", desc: "In-line, pocket and lift-slide steel doors." },
      { name: "Arched", desc: "Bespoke arched pivots and swings — signature statements." },
      { name: "Custom", desc: "One-off systems engineered around your drawings." },
    ],
    galleryStyle: "lifestyle",
    gallery: [
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/1gve54in_DSCF4359.webp",
        name: "Internal French Doors + Sidelights",
        spec: "W20 Steel · Colonial grid · Matte-black frames",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/ztqztwhp_DSCF4278.webp",
        name: "External French Doors",
        spec: "Weatherproofed steel · Colonial grid · Thermal seals",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/glpjkk8p_DSCF4227.webp",
        name: "Reeded-Glass Internal Door",
        spec: "Single-leaf steel · Fluted privacy glass · Slim mullions",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/712fant2_DSCF3958%202.webp",
        name: "Steel Screen with Reeded Base",
        spec: "Room divider · Clear + reeded panels · Concealed hinges",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/ix03rbke_DSCF1731%202.webp",
        name: "Arched Double Doors, Reeded Glass",
        spec: "Bespoke arch · Twin vertical pulls · Reeded privacy glass",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/oosz2qbt_IMG_4598.webp",
        name: "French Doors Onto Foyer",
        spec: "Four-lite grid · Twin swing · Slim mullions",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/17bkobb5_IMG_4596.webp",
        name: "Reeded Glass Handle Detail",
        spec: "Matte-black pull · Fluted privacy pane · Slim frame",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/twvu90op_IMG_4597.webp",
        name: "Arched Double Reeded, Classic Interior",
        spec: "Bespoke arch · Twin pulls · Panelled surround",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/2o8srg8b_DSCF4223.webp",
        name: "Arched Reeded Panel, Painted Frame",
        spec: "Full-arch profile · Painted trim to match walls",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/y3b9aqcs_DSCF4215%202.webp",
        name: "Reeded Steel Single Leaf, Panelled Room",
        spec: "Three-lite reeded glass · Matte black · Slim frame",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/57pe3fj6_unnamed.webp",
        name: "Kitchen-to-Hallway Steel Door",
        spec: "Slim steel with transom · Clear glazing · Matte black",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/br4hnu69_DSCF4198.webp",
        name: "Grand Entry Double Doors",
        spec: "Colonial-grid steel · Stucco portico · Statement entrance",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/x79mi3dh_Ottostumm%20Mogs%20FerroFinestra%20W75%20%281%29%20%281%29.jpg",
        name: "Industrial Pivot — Concrete Portico",
        spec: "Oversized pivot · Full-height glazing · Brutalist context",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/sjuqsk34_Ottostumm%20Mogs%20-%20FerroFinestra%20W20.jpg",
        name: "Bronze Handle & Brass Keeper Detail",
        spec: "Solid bronze T-handle · Brass strike plate · Steel frame",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/drfekior_IMG_8495.webp",
        name: "Arched Pivot to Pool Courtyard",
        spec: "Full-arch pivot · Checkerboard threshold · Poolside entry",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/rkynoioy_DSCF1731%202.webp",
        name: "Internal French Doors + Sidelights",
        spec: "Wide double-leaf · Twin sidelights · Wood-floor entry",
      },
    ],
  },
  "steel-windows": {
    slug: "steel-windows",
    title: "Steel Windows.",
    eyebrow: "Category",
    tagline: "Casement, Awning, Fixed, Arched",
    description:
      "Slim steel windows that let the architecture breathe. Casement, awning, fixed and arched — with double-glazing for New Zealand's climate.",
    seo: {
      title: "Steel Windows NZ — Slimline Architectural Windows | EUROSTEEL",
      description:
        "Slimline architectural steel windows for New Zealand — casement, awning, fixed and arched profiles with thermal double-glazing for coastal and alpine climates.",
      keywords: [
        "steel windows NZ",
        "architectural steel windows NZ",
        "custom steel windows NZ",
        "slimline steel windows NZ",
      ],
    },
    intro:
      "A steel window is the quietest way to hold a wall of glass. The FerroFinestra profile gives sight-lines a few millimetres thick, so the architecture reads first and the joinery reads second. Every EUROSTEEL window is drawn to the opening, thermally-broken where the climate calls for it, and glazed with double units that meet NZBC H1 without compromising the line.",
    relatedSlugs: ["steel-doors", "luxury-entrances"],
    heroImage:
      "https://customer-assets-v7afamib.emergentagent.net/job_fe0c775c-382e-4bf1-ab8e-bb795dea130b/artifacts/s5295zz0_Ottostumm%20Mogs%20FerroFinestra%20%20B75%20TB%202.webp",
    items: [
      { name: "Casement", desc: "Side-hinged windows with slim sight-lines." },
      { name: "Awning", desc: "Top-hung windows for kitchens and wet rooms." },
      { name: "Fixed Lights", desc: "Full-height fixed windows and clerestories." },
      { name: "Arched", desc: "Bespoke arched steel windows in heritage restorations." },
      { name: "Combination", desc: "Fixed + operable panels in a single steel screen." },
    ],
    galleryStyle: "lifestyle",
    gallery: [
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/f0bzmhkr_Ottostumm%20Mogs%20-%20FerroFinestra%20W20%20b.jpg",
        name: "Factory-Style Studio Windows",
        spec: "W20 FerroFinestra · Colonial grid · Full-height glazing",
      },
    ],
  },
  designs: {
    slug: "designs",
    title: "Designs.",
    eyebrow: "",
    tagline: "Design renders for inspiration",
    description:
      "A selection of design renders to spark ideas — every profile, glazing, handle and finish shown here can be tailored to your project. We build custom configurations from the ground up in steel, so if you can draw it, we can make it.",
    heroImage:
      "https://customer-assets-0z36b82j.emergentagent.net/job_90d22f1f-b078-4e8d-bee2-20170bd7c0ae/artifacts/ishxizyi_IMG_4597.webp",
    layoutStyle: "clean",
    codePrefix: "D",
    hideFilters: true,
    items: [
      { name: "Bespoke Doors", desc: "One-off door designs, unique profiles and finishes." },
      { name: "Heritage Restoration", desc: "Crittall-style replacement in period buildings." },
      { name: "Screens & Partitions", desc: "Internal steel screens for rooms within rooms." },
      { name: "Facades", desc: "Structural steel-glazed facades and clerestories." },
    ],
    gallery: [],
    lifestyleGallery: [
      {
        src: "https://customer-assets-0z36b82j.emergentagent.net/job_90d22f1f-b078-4e8d-bee2-20170bd7c0ae/artifacts/ishxizyi_IMG_4597.webp",
        name: "Arched Double Reeded — Classic Interior",
        spec: "Bespoke arch · Twin pulls · Panelled surround",
        type: "door",
        profile: "Custom Arched Steel",
        dimensions: "1600 × 2600 mm · Radius 800 mm",
        glazing: "Reeded fluted privacy glass — full height",
        finish: "Matte-black · Twin vertical pulls",
      },
      {
        src: "https://customer-assets-0z36b82j.emergentagent.net/job_90d22f1f-b078-4e8d-bee2-20170bd7c0ae/artifacts/w5fiazni_IMG_4596.webp",
        name: "Painted Arch Reeded — Colour-Matched Frame",
        spec: "Full-arch profile · Painted tone-in-tone with walls",
        type: "door",
        profile: "Custom Arched Steel",
        dimensions: "1000 × 2600 mm · Radius 500 mm",
        glazing: "Reeded fluted privacy glass",
        finish: "Painted frame — colour-matched to interior",
      },
      {
        src: "https://customer-assets-0z36b82j.emergentagent.net/job_90d22f1f-b078-4e8d-bee2-20170bd7c0ae/artifacts/fxcbe9kn_IMG_7194.webp",
        name: "Arched Wine Cellar — Clear Vision",
        spec: "Full-height arch · Slim mid rail · Clear glazing",
        type: "door",
        profile: "W20 Steel",
        dimensions: "900 × 2600 mm · Radius 450 mm",
        glazing: "6mm clear tempered — single arched pane",
        finish: "Matte-black · Slim horizontal handle",
      },
      {
        src: "https://customer-assets-0z36b82j.emergentagent.net/job_90d22f1f-b078-4e8d-bee2-20170bd7c0ae/artifacts/21qc85mm_IMG_7195.webp",
        name: "Wine Vault Screen — Twin Arched Panels",
        spec: "Oversized arched screen · Divided lites · Fixed & swing pair",
        type: "screen",
        profile: "W40 Steel",
        dimensions: "2400 × 2700 mm · Radius 1200 mm",
        glazing: "6mm clear tempered — divided into six lites",
        finish: "Matte-black · Recessed pulls",
      },
      {
        src: "https://customer-assets-0z36b82j.emergentagent.net/job_90d22f1f-b078-4e8d-bee2-20170bd7c0ae/artifacts/plbhpn7c_IMG_4598.webp",
        name: "Four-Lite Reeded — Slim Steel Leaf",
        spec: "Single-leaf entry · Four horizontal lites · Reeded glass",
        type: "door",
        profile: "W20 Steel",
        dimensions: "900 × 2400 mm",
        glazing: "Reeded fluted privacy glass — four lites",
        finish: "Matte-black · Round knob · Slim bar handle",
      },
      {
        src: "https://customer-assets-0z36b82j.emergentagent.net/job_90d22f1f-b078-4e8d-bee2-20170bd7c0ae/artifacts/uzi8pfol_IMG_4973.webp",
        name: "Arched Double — Clear Vision Pair",
        spec: "Twin arched leaves · Full clear glazing · Hearth view",
        type: "door",
        profile: "Custom Arched Steel",
        dimensions: "1600 × 2600 mm · Radius 800 mm",
        glazing: "6mm clear tempered — full arched leaves",
        finish: "Matte-black · Twin vertical pulls",
      },
      {
        src: "https://customer-assets-0z36b82j.emergentagent.net/job_90d22f1f-b078-4e8d-bee2-20170bd7c0ae/artifacts/lzur9p41_IMG_4972.webp",
        name: "Grid Double — Four-Panel Symmetry",
        spec: "Twin leaves · Four-panel divided lite · Slim mullions",
        type: "door",
        profile: "W20 Steel",
        dimensions: "1600 × 2600 mm · Leaves 800 × 2600 mm",
        glazing: "6mm clear tempered — four lites per leaf",
        finish: "Matte-black · Slim lever handles",
      },
      {
        src: "https://customer-assets-eiarnc6j.emergentagent.net/job_c8c33088-e275-4c7a-be4e-9570c082ca94/artifacts/j8i7tzer_IMG_4971.webp",
        name: "Banded Reeded Double — Privacy Strip",
        spec: "Twin leaves · Clear over/under · Reeded privacy band",
        type: "door",
        profile: "W20 Steel",
        dimensions: "1500 × 2400 mm · Leaves 750 × 2400 mm",
        glazing: "Clear tempered + reeded mid-band lite",
        finish: "Matte-black · Slim lever handles",
      },
      {
        src: "https://customer-assets-0z36b82j.emergentagent.net/job_90d22f1f-b078-4e8d-bee2-20170bd7c0ae/artifacts/2yjoqyqo_IMG_4970.webp",
        name: "Two-Lite Single — Slim Clear Leaf",
        spec: "Single-leaf entry · Two horizontal lites · Clear vision",
        type: "door",
        profile: "W20 Steel",
        dimensions: "900 × 2400 mm",
        glazing: "6mm clear tempered — two lites",
        finish: "Matte-black · Slim lever handle",
      },
      {
        src: "https://customer-assets-0z36b82j.emergentagent.net/job_90d22f1f-b078-4e8d-bee2-20170bd7c0ae/artifacts/goijw5ru_IMG_7196.webp",
        name: "Wine Cellar Pair — Divided Vision",
        spec: "Double leaves · Fixed + swing · Divided lites into cellar",
        type: "door",
        profile: "W20 Steel",
        dimensions: "1400 × 2400 mm · Leaves 700 × 2400 mm",
        glazing: "6mm clear tempered — four divided lites per leaf",
        finish: "Matte-black · Slim lever + pull",
      },
      {
        src: "https://customer-assets-0z36b82j.emergentagent.net/job_90d22f1f-b078-4e8d-bee2-20170bd7c0ae/artifacts/vi8bnyvm_IMG_7606.webp",
        name: "Arched Reeded Pair",
        type: "door",
        isStudio: true,
      },
      {
        src: "https://customer-assets-0z36b82j.emergentagent.net/job_90d22f1f-b078-4e8d-bee2-20170bd7c0ae/artifacts/wpu2oxy6_IMG_7604.webp",
        name: "Transom Double Pivot",
        type: "door",
        isStudio: true,
      },
      {
        src: "https://customer-assets-0z36b82j.emergentagent.net/job_90d22f1f-b078-4e8d-bee2-20170bd7c0ae/artifacts/vu3bqzna_IMG_7603.webp",
        name: "Solid Panel with Twin Sidelights",
        type: "door",
        isStudio: true,
      },
      {
        src: "/doors/d-studio-reeded-double-sidelights.webp",
        name: "Reeded Panel · Twin Sidelights",
        type: "door",
        isStudio: true,
      },
      {
        src: "https://customer-assets-0z36b82j.emergentagent.net/job_90d22f1f-b078-4e8d-bee2-20170bd7c0ae/artifacts/f9mqjhv0_2%20%282%29.webp",
        name: "Reeded Panel · Round Handle",
        type: "door",
        isStudio: true,
      },
    ],
  },
  "luxury-entrances": {
    slug: "luxury-entrances",
    title: "Luxury Entrances.",
    eyebrow: "Category",
    tagline: "Statement Doors — Pivot, Arched, Oversized",
    description:
      "First impressions in steel. Oversized pivots, arched entryways and bespoke double doors — engineered for architectural statement pieces where the front door is the hero of the build.",
    seo: {
      title: "Luxury Steel Entrances NZ — Oversized Pivot & Arched Doors | EUROSTEEL",
      description:
        "Statement front doors in steel — oversized pivots, arched entrances and bespoke double leaves for high-end New Zealand residences and boutique commercial builds.",
      keywords: [
        "luxury steel doors NZ",
        "steel entrance doors NZ",
        "oversized pivot doors NZ",
      ],
    },
    intro:
      "The front door is where a building introduces itself. EUROSTEEL entrances are drawn as architecture in their own right — floor-mounted pivots up to three metres tall, arched double leaves cut to the radius of the portico, and bespoke sidelights that carry the same sight-line right across the façade.",
    relatedSlugs: ["steel-doors", "steel-windows"],
    heroImage:
      "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/ahvi39e0_IMG_7606.webp",
    items: [
      { name: "Oversized Pivots", desc: "Statement pivot doors on floor-mounted hinges — up to 3m tall." },
      { name: "Arched Entryways", desc: "Bespoke arched steel doors as signature façade moments." },
      { name: "Bespoke Double Doors", desc: "Wide double-leaf entrances with concealed hinges." },
      { name: "Brass & Bronze Hardware", desc: "Solid brass and bronze pulls, powder-coated to your palette." },
      { name: "Sidelights & Fanlights", desc: "Matching steel screens flanking the entrance for a unified look." },
      { name: "Weathering & Sealing", desc: "Threshold detailing engineered for NZ exposure and coastal conditions." },
    ],
    gallery: [
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/ahvi39e0_IMG_7606.webp",
        name: "Oversized Double Pivot",
        spec: "Wide twin-leaf pivot · Concealed pivots · Vertical pulls",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/pjrwqkjg_IMG_7603.webp",
        name: "Arched Fluted Double",
        spec: "Ribbed steel · Arched crown · Statement entryway",
      },
      {
        src: "https://customer-assets-v7afamib.emergentagent.net/job_3cc12260-5622-4383-abad-481c3375154e/artifacts/vgu4xcxa_IMG_7600.webp",
        name: "Arched Fluted Double — Variant",
        spec: "Full-height flute · Radius top · Matte-black finish",
      },
    ],
  },
};

export const CATEGORY_SLUGS = Object.keys(CATEGORIES);
